
<template>
  <div class="app-content">
    <div class="head-container"
         style="height: 160px;">
      <img src="../assets/head-bg.png"
           alt="head_bg"
           class="head-bg">
      <div class="person-info-wrap">
        <img src="../assets/touxiang.png"
             alt="avatar"
             class="avatar">
        <div>
          <div v-if="token"
               class="user-name-unlogin">信众{{phone}}</div>
          <div v-if="!token"
               class="user-status-unlogin">登录查看更多</div>
        </div>
      </div>
    </div>
    <!-- <div class="menu-container">
      <div class="menu-item">
        <img src="../assets/jinqifahui.png" alt="img">
        <div>
          <div class="item-title">近期法会</div>
          <div class="item-desc">报名的法会</div>
        </div>
      </div>
      <div class="menu-item">
        <img src="../assets/jingshengongde.png" alt="img">
        <div>
          <div class="item-title">敬神功德</div>
          <div class="item-desc">我的功德</div>
        </div>
      </div>
      <div class="menu-item">
        <img src="../assets/qifudeng.png" alt="img">
        <div>
          <div class="item-title">祈福灯</div>
          <div class="item-desc">我的祈福灯</div>
        </div>
      </div>
    </div> -->
    <div class="my-order-container">
      <div class="order-title">我的订单</div>
      <div class="order-item-wrap">
        <div class="order-item"
             @click="goQuanBu">
          <img src="../assets/dingdan.png"
               alt="img">
          <div class="item-title">全部</div>
        </div>
        <div class="order-item"
             @click="goDaizhifu">
          <img src="../assets/daizhifu.png"
               alt="img">
          <div class="item-title">待支付</div>
        </div>
        <!-- <div class="order-item">
          <img src="/temple/static/img/calendar.png" alt="img"> 
          <div class="item-title">待出行</div>
        </div>
        <div class="order-item">
          <img src="/temple/static/img/money-arrow.png" alt="img"> 
          <div class="item-title">退款/售后</div>
        </div> -->
        <div class="order-item"
             @click="goFinish">
          <img src="../assets/yiwancheng.png"
               alt="img">
          <div class="item-title">已完成</div>
        </div>
      </div>
    </div>
    <div class="common-functions-container">
      <div class="functions-title">常用功能</div>
      <div class="functions-item-wrap">
        <div class="functions-item">
          <img src="../assets/changyongxinxi.png"
               alt="img">
          <div class="item-title"
               @click="goContactList">常用信息</div>
        </div>
        <div class="functions-item">
          <img src="../assets/yinsixieyi.png"
               alt="img">
          <div class="item-title"
               @click="goXieYi">隐私协议</div>
        </div>
        <!-- <div class="functions-item">
          <img src="../assets/changyongxinxi.png"
               alt="img">
          <div class="item-title"
               @click="goLoginOut">退出登录</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user',
  data() {
    return {
      phone: localStorage.getItem("phoneExt"),
      token: localStorage.getItem("token"),
    }

  },
  methods: {
    goContactList() {
      this.$router.push("/contactList")
    },
    goToLogin() {
      this.$router.push("/login")
    },
    goQuanBu() {
      this.$router.push({ name: "QuBuDingDan", params: { type: 0 } })
      localStorage.setItem("zf_type", 0)
    },
    goDaizhifu() {
      this.$router.push({ name: "QuBuDingDan", params: { type: 1 } })
      localStorage.setItem("zf_type", 1)
    },
    goFinish() {
      this.$router.push({ name: "QuBuDingDan", params: { type: 2 } })
      localStorage.setItem("zf_type", 2)
    },
    goXieYi() {
      this.$router.push("/HeTong")
    },
    goLoginOut() {
      localStorage.setItem("token", "")
    }
  },
  created() {
    localStorage.setItem("zf_type", 0)
  }

}
</script>

<style>
.app-content {
}

.head-container {
  position: relative;
  margin-bottom: -46px;
}

.head-bg {
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: -1;
}

.person-info-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 24px 32px 16px;
}

.avatar {
  width: 72px;
  height: 72px;
  margin-right: 16px;
}

.user-name-unlogin {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 700;
  color: #000;
}

.user-status-unlogin {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
  margin-top: 8px;
}

/* .menu-container {
  background-color: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, .1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, .1);
  border-radius: 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 19px 0;
  margin: 0 16px;
  position: relative;
  z-index: 1;
} */

.menu-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.menu-item img {
  width: 30px;
  height: 30px;
  margin-right: 8px;
}

.item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
}

.item-desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}

.my-order-container {
  background-color: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 16px 16px 0;
}

.order-title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #000;
  padding: 12px 0 0 16px;
}

.order-item-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.order-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  padding: 16px 0;
}

.order-item img {
  width: 24px;
  height: 24px;
}
.order-item .item-title {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  margin-top: 8px;
}
.common-functions-container {
  background-color: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 16px 16px 0;
}

.functions-title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #000;
  line-height: 22px;
  padding: 12px 16px 8px;
}

.functions-item-wrap {
  padding: 0 16px 8px;
}

.functions-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 48px;
}

.functions-item img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
</style>